import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { X } from "lucide-react";
import { createPortal } from "react-dom";
import { Pencil, Trash2 } from "lucide-react";

const UpdateInventoryModal = ({ isOpen, onClose, itemData }) => {
  const [itemTypes, setItemTypes] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    item_type_id: "",
    item_units: 1,
    status: "Not Assignable",
    vendor_name: "",
    v_mobile_no: "",
    purchase_date: "",
    warranty_date: "",
    additional_info: "",
    invoice_image: null,
    item_image: null,
  });

  const [loading, setLoading] = useState(false);

  const getItemTypes = async () => {
    const token = Cookies.get("token");
    try {
      const res = await axios.get(
        "https://demouptask.visiontrek.io/api/inventory/types",
        // "https://192.168.1.16:5555/api/inventory/types",

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.success) {
        const sortedData = res.data.data.sort((a, b) => a.id - b.id);
        setItemTypes(sortedData);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (isOpen && itemData) {
      getItemTypes();

      setFormData({
        name: itemData.name || "",
        item_type_id: itemData.item_type_id || "",
        item_units: itemData.item_units || 1,
        status: itemData.status || "Not Assignable",
        vendor_name: itemData.vendor_name || "",
        v_mobile_no: itemData.v_mobile_no || "",
        purchase_date: itemData.purchase_date || "",
        warranty_date: itemData.warranty_date || "",
        additional_info: itemData.additional_info || "",
      });

      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen, itemData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = Cookies.get("token");

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("name", formData.name);
      formDataToSend.append("item_type_id", formData.item_type_id || "");
      formDataToSend.append("item_units", formData.item_units || 1);
      formDataToSend.append("status", formData.status);
      formDataToSend.append("vendor_name", formData.vendor_name);
      formDataToSend.append("v_mobile_no", formData.v_mobile_no);
      // formDataToSend.append("purchase_date", formData.purchase_date || "");
      // formDataToSend.append("warranty_date", formData.warranty_date || "");

      // ✅ ONLY send if value exists
      if (formData.purchase_date) {
        formDataToSend.append("purchase_date", formData.purchase_date);
      }

      if (formData.warranty_date) {
        formDataToSend.append("warranty_date", formData.warranty_date);
      }



      formDataToSend.append("additional_info", formData.additional_info);

      // ✅ IMPORTANT: append image
      if (formData.invoice_image) {
        formDataToSend.append("invoice_image", formData.invoice_image);
      }
      if (formData.item_image) {
        formDataToSend.append("item_image", formData.item_image);
      }

      console.log("📦 FormData:");
      for (let pair of formDataToSend.entries()) {
        console.log(pair[0], pair[1]);
      }

      const res = await axios.put(
        `https://demouptask.visiontrek.io/api/inventory/${itemData.item_id}`,
        // `https://192.168.1.16:5555/api/inventory/${itemData.item_id}`,

        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // ✅ MUST
          },
        }
      );

      if (res.data?.success) {
        onClose(true);
      }

    } catch (error) {
      console.error("❌ Upload Error:", error);
      alert("Failed to update inventory");
    } finally {
      setLoading(false);
    }
  };




  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
      <div
        className="
        relative z-[10000]
        w-full max-w-4xl max-h-[85vh]
        rounded-2xl
        bg-white/15 backdrop-blur-xl
        shadow-2xl border border-white/20
        text-white
        overflow-hidden
      "
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 bg-gradient-to-r from-[#2d1c6a] to-[#24155a]">
          <h2 className="font-semibold text-lg">
            Update Inventory Item
          </h2>
          <X
            size={22}
            onClick={onClose}
            className="cursor-pointer text-white/80 hover:text-red-300"
          />
        </div>

        {/* Body */}
        <form
          onSubmit={handleSubmit}
          className="p-6 overflow-y-auto max-h-[calc(85vh-70px)] space-y-4"
        >
          <div className="grid grid-cols-2 gap-4">




            <InputField label="Item Name" required>
              <input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="bg-white/10 border border-white/20 p-2 rounded"
              />
            </InputField>






            <InputField label="Item Type" required>
              <select
                name="item_type_id"
                value={formData.item_type_id}
                onChange={handleInputChange}
                className="bg-white text-gray-800 p-2 rounded"
              >
                <option value="" className="bg-white text-black">Select Item Type</option>
                {itemTypes.map((type) => (
                  <option key={type.id} value={type.id} className="bg-white text-black">
                    {type.item_type}
                  </option>
                ))}
              </select>
            </InputField>




            <InputField label="Units" required>
              <input
                type="number"
                name="item_units"
                value={formData.item_units}
                onChange={handleInputChange}
                className="bg-white/10 border border-white/20 p-2 rounded"
              />
            </InputField>






            <InputField label="Status" required>
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                className="bg-white text-gray-800 p-2 rounded"
              >
                {/* <option value="Idle">Idle</option>
    <option value="In Use">In Use</option>
    <option value="Maintenance">Maintenance</option> */}
                <option value="Not Assignable" className="bg-white text-black">Not Assignable</option>
                <option value="Assignable" className="bg-white text-black">Assignable</option>
                <option value="Assigned" className="bg-white text-black">Assigned</option>
              </select>
            </InputField>




            <InputField label="Vendor Name">
              <input
                name="vendor_name"
                value={formData.vendor_name}
                onChange={handleInputChange}
                className="bg-white/10 border border-white/20 p-2 rounded"
              />
            </InputField>




            <InputField label="Vendor Mobile">
              <input
                name="v_mobile_no"
                value={formData.v_mobile_no}
                onChange={handleInputChange}
                placeholder="Vendor Mobile"
                className="bg-white/10 border border-white/20 placeholder:text-white/90 p-2 rounded"
              />
            </InputField>



            <InputField label="Invoice Image">
              <input
                type="file"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    invoice_image: e.target.files[0],
                  }))
                }
                className="bg-white/10 border border-white/20 p-2 rounded"
              />
            </InputField>



            <InputField label="Item Image">
              <input
                type="file"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    item_image: e.target.files[0],
                  }))
                }
                className="bg-white/10 border border-white/20 p-2 rounded"
              />
            </InputField>

            <InputField label="Purchase Date">
              <input
                type="date"
                name="purchase_date"   // ✅ FIXED
                value={formData.purchase_date}
                onChange={handleInputChange}
                className="bg-white text-gray-800 p-2 rounded"
              />
            </InputField>

            <InputField label="Warranty Date">
              <input
                type="date"
                name="warranty_date"
                value={formData.warranty_date}
                onChange={handleInputChange}
                className="bg-white text-gray-800 p-2 rounded"
              />

            </InputField>
          </div>

          <textarea
            name="additional_info"
            value={formData.additional_info}
            onChange={handleInputChange}
            placeholder="Additional Info"
            className="w-full bg-white/10 border border-white/20 p-2 rounded"
          />

          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-white/10 rounded"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-purple-600 rounded"
            >
              {loading ? "Updating..." : "Update Item"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default UpdateInventoryModal;




function InputField({ label, required = false, children }) {
  return (
    <div className="flex flex-col">
      <label className="text-sm mb-1 text-white/80">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      {children}
    </div>
  );
}


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { X } from "lucide-react";
// import { createPortal } from "react-dom";

// const UpdateInventoryModal = ({ isOpen, onClose, itemData }) => {
//   const [itemTypes, setItemTypes] = useState([]);
//   const [formData, setFormData] = useState({
//     name: "",
//     item_type_id: "",
//     item_units: 1,
//     status: "Idle",
//     vendor_name: "",
//     v_mobile_no: "",
//     purchase_date: "",
//     warranty_date: "",
//     additional_info: "",
//     invoice_image: null,
//   });

//   const [loading, setLoading] = useState(false);

//   const getItemTypes = async () => {
//     const token = Cookies.get("token");
//     try {
//       const res = await axios.get(
//         "https://uptask.visiontrek.io/api/inventory/types",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (res.data?.success) {
//         const sortedData = res.data.data.sort((a, b) => a.id - b.id);
//         setItemTypes(sortedData);
//       }
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   useEffect(() => {
//     if (isOpen && itemData) {
//       getItemTypes();

//       setFormData({
//         name: itemData.name || "",
//         item_type_id: itemData.item_type_id || "",
//         item_units: itemData.item_units || 1,
//         status: itemData.status || "Idle",
//         vendor_name: itemData.vendor_name || "",
//         v_mobile_no: itemData.v_mobile_no || "",
//         purchase_date: itemData.purchase_date || "",
//         warranty_date: itemData.warranty_date || "",
//         additional_info: itemData.additional_info || "",
//       });

//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }
//   }, [isOpen, itemData]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);

//   //   const token = Cookies.get("token");

//   //   try {
//   //     const res = await axios.put(
//   //       `https://uptask.visiontrek.io/api/inventory/${itemData.id}`,
//   //       formData,
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //           "Content-Type": "application/json",
//   //         },
//   //       }
//   //     );

//   //     if (res.data?.success) {
//   //       onClose();
//   //     }
//   //   } catch (error) {
//   //     alert("Failed to update inventory");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };



// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);

//   const token = Cookies.get("token");

//   try {
//     const data = new FormData();

//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== null) {
//         data.append(key, formData[key]);
//       }
//     });

//     const res = await axios.put(
//       `https://uptask.visiontrek.io/api/inventory/${itemData.id}`,
//       data,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );

//     // if (res.data?.success) {
//     //   onClose();
//     // }


//     if (res.data?.success) {
//       onClose(true); // ✅ PASS TRUE
//     }


//   } catch (error) {
//     alert("Failed to update inventory");
//   } finally {
//     setLoading(false);
//   }
// };







//   if (!isOpen) return null;

//   return createPortal(
//     <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
//       <div
//         className="
//         relative z-[10000]
//         w-full max-w-4xl max-h-[85vh]
//         rounded-2xl
//         bg-white/15 backdrop-blur-xl
//         shadow-2xl border border-white/20
//         text-white
//         overflow-hidden
//       "
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center px-6 py-4 bg-gradient-to-r from-[#2d1c6a] to-[#24155a]">
//           <h2 className="font-semibold text-lg">
//             Update Inventory Item
//           </h2>
//           <X
//             size={22}
//             onClick={onClose}
//             className="cursor-pointer text-white/80 hover:text-red-300"
//           />
//         </div>

//         {/* Body */}
//         <form
//           onSubmit={handleSubmit}
//           className="p-6 overflow-y-auto max-h-[calc(85vh-70px)] space-y-4"
//         >
//           <div className="grid grid-cols-2 gap-4">

//             <input
//               name="name"
//               value={formData.name}
//               onChange={handleInputChange}
//               placeholder="Item Name"
//               className="bg-white/10 border border-white/20 placeholder:text-white/90 p-2 rounded"
//             />

//             <select
//               name="item_type_id"
//               value={formData.item_type_id}
//               onChange={handleInputChange}
//               className="bg-white text-gray-800 p-2 rounded"
//             >
//               <option value="">Select Item Type</option>
//               {itemTypes.map((type) => (
//                 <option key={type.id} value={type.id}>
//                   {type.item_type}
//                 </option>
//               ))}
//             </select>

//             <input
//               type="number"
//               name="item_units"
//               value={formData.item_units}
//               onChange={handleInputChange}
//               placeholder="Units"
//               className="bg-white/10 border border-white/20 placeholder:text-white/90 p-2 rounded"
//             />

//             <select
//               name="status"
//               value={formData.status}
//               onChange={handleInputChange}
//               className="bg-white text-gray-800 p-2 rounded"
//             >
//               <option value="Idle">Idle</option>
//               <option value="In Use">In Use</option>
//               <option value="Maintenance">Maintenance</option>
//             </select>

//             <input
//               name="vendor_name"
//               value={formData.vendor_name}
//               onChange={handleInputChange}
//               placeholder="Vendor Name"
//               className="bg-white/10 border border-white/20 placeholder:text-white/90 p-2 rounded"
//             />

//             <input
//               name="v_mobile_no"
//               value={formData.v_mobile_no}
//               onChange={handleInputChange}
//               placeholder="Vendor Mobile"
//               className="bg-white/10 border border-white/20 placeholder:text-white/90 p-2 rounded"
//             />



// <input
//   type="file"
//   name="invoice_image"
//   onChange={(e) =>
//     setFormData((prev) => ({
//       ...prev,
//       invoice_image: e.target.files[0],
//     }))
//   }
//   className="bg-white/10 border border-white/20 p-2 rounded col-span-2"
// />

//             <input
//               type="date"
//               name="purchase_date"
//               value={formData.purchase_date}
//               onChange={handleInputChange}
//               className="bg-white text-gray-800 p-2 rounded"
//             />

//             <input
//               type="date"
//               name="warranty_date"
//               value={formData.warranty_date}
//               onChange={handleInputChange}
//               className="bg-white text-gray-800 p-2 rounded"
//             />
//           </div>

//           <textarea
//             name="additional_info"
//             value={formData.additional_info}
//             onChange={handleInputChange}
//             placeholder="Additional Info"
//             className="w-full bg-white/10 border border-white/20 p-2 rounded"
//           />

//           <div className="flex justify-end gap-3 pt-4">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 py-2 bg-white/10 rounded"
//             >
//               Cancel
//             </button>

//             <button
//               type="submit"
//               disabled={loading}
//               className="px-6 py-2 bg-purple-600 rounded"
//             >
//               {loading ? "Updating..." : "Update Item"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>,
//     document.body
//   );
// };

// export default UpdateInventoryModal;


